import { NavLink } from 'react-router-dom'
import { Modal } from '../ui/Modal'
import { useAuth } from '../../auth/AuthContext'
import { MOBILE_MORE_ITEMS } from './navItems'
import styles from './MoreMenuModal.module.css'

export function MoreMenuModal({ onClose }: { onClose: () => void }) {
  const { hasAnyPermission } = useAuth()
  const items = MOBILE_MORE_ITEMS.filter((item) => !item.requiredPermissions || hasAnyPermission(item.requiredPermissions))

  return (
    <Modal title="Mehr" onClose={onClose}>
      <div className={styles.list}>
        {items.map((item) => (
          <NavLink key={item.to} to={item.to} onClick={onClose} className={styles.item}>
            <span className={styles.icon}>{item.icon}</span>
            <span>{item.label}</span>
          </NavLink>
        ))}
      </div>
    </Modal>
  )
}
